import React from 'react';

export function VoiceEnrollLoading() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f2f4f8' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '24px', marginBottom: '16px' }}>Loading...</div>
      </div>
    </div>
  );
}

export function VoiceEnrollError({ message }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f2f4f8' }}>
      <div style={{ textAlign: 'center', padding: '32px', background: 'white', borderRadius: '16px', maxWidth: '400px' }}>
        <h2 style={{ color: '#e53935', marginBottom: '16px' }}>Error</h2>
        <p style={{ color: '#4b5563' }}>{message}</p>
      </div>
    </div>
  );
}

export function VoiceEnrollSuccess({ name, message }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f2f4f8' }}>
      <div style={{ textAlign: 'center', padding: '48px', background: 'white', borderRadius: '16px', maxWidth: '450px', boxShadow: '0 16px 40px rgba(0,0,0,0.1)' }}>
        <div style={{ fontSize: '64px', marginBottom: '24px' }}>✅</div>
        <h2 style={{ color: '#0d4a33', marginBottom: '16px' }}>Voice Recorded!</h2>
        <p style={{ color: '#4b5563', fontSize: '16px', lineHeight: '1.6' }}>
          Thank you <strong>{name}</strong>! Your voice recording has been saved successfully.
        </p>
        <p style={{ color: '#6b7280', fontSize: '14px', marginTop: '24px' }}>
          {message}
        </p>
      </div>
    </div>
  );
}

export function VoiceEnrollErrorBanner({ message }) {
  if (!message) return null;
  return (
    <div style={{ background: '#fee2e2', color: '#dc2626', padding: '16px', borderRadius: '8px', marginBottom: '24px', textAlign: 'center' }}>
      {message}
    </div>
  );
}
